import { render, staticRenderFns } from "./editBuilding.vue?vue&type=template&id=3a3fbfbe&scoped=true&"
import script from "./editBuilding.vue?vue&type=script&lang=js&"
export * from "./editBuilding.vue?vue&type=script&lang=js&"
import style0 from "./editBuilding.vue?vue&type=style&index=0&id=3a3fbfbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fbfbe",
  null
  
)

export default component.exports